<template>
    <horizontal-timeline 
      :id="id"
      :resource="resource"
    />
    <div v-if="enable" class="p-fluid p-grid p-col-12 p-formgrid">
       <div class="p-field p-col-12 p-md-2 p-field-btn">
          <p-button 
            label="Reject" 
            icon="pi pi-times-circle" @click="startFeedBack()" class="p-button"  />
       </div>
       <div class="p-field p-col-12 p-md-5 p-field-btn">
          <p-button 
            label="Request Information" 
            icon="pi pi-info-circle" @click="dialogFlag = true"  class="p-button"  />
       </div>

         <div class="p-field p-col-12 p-md-5 p-field-btn">
          <p-button 
            label="Approve" 
            icon="pi pi-check-circle" @click="startFeedBack('APPROVE')" class="p-button"  />
       </div>
    </div>
    <p-dialog style="margin: 10px" header="Enter Remarks" v-model:visible="dialogFlag">
      <div style="min-width:600px">
        <div class="p-fluid p-grid p-col-12 p-formgrid">
          <div class="p-field p-col-12">  
            <h3 class="m-1">Remarks</h3>
            <p-textarea
               v-model.trim="remarks"
              type="text"
              placeholder="Enter remarks"
             />
           </div>
          <div class="p-field p-col-12 p-md-6 p-field-btn">
              <p-button 
                label="Cancel" 
                icon="pi pi-times-circle" @click="dialogFlag = false" class="p-button"  />
          </div>
          <div class="p-field p-col-12 p-md-6 p-field-btn">
              <p-button 
                label="Request Information" 
                icon="pi pi-check-circle" @click="startFeedBack('REQUEST')"  class="p-button"  />
          </div>
        </div>
      </div>
    </p-dialog>
</template>

<script lang="ts">
  import { base } from "../misc/base";
import { Options, Vue } from "vue-class-component";
  
  @Options({
    props: {
      id: String,
      resource : String,
    },
    emits: ["close"]
  })
  export default class ApprovalBar extends base {
    id!: string;
    resource!: string;
    dialogFlag = false;
    remarks! : string;
    enable = false

    mounted(){
      const service = this.store.state.simforce

      service.get(
        `/approve/can_evaluate/${this.resource}`,
      )
      .then(res => {

        if(this.id)
          this.enable = true
      })
      .catch(e => {
        console.log(e)
      })
    }

    successFeedBack(){
        // Use this.toast instead of this.$toast to avoid Vue warnings
        this.toast.add({
          severity: "success",
          summary: `Feedback sent`,
          detail: `Resource updated!`,
          life: 5000,
        });
        this.$emit("close")
      
      }

      errorFeedBack(e : any){
        let err = e.response?.data || { error: 'Unknown error occurred' }
        // Use this.toast instead of this.$toast to avoid Vue warnings
        this.toast.add({
          severity: "error",
          summary: "Error recording feedback",
          detail: err.err ? err.err : err.error,
          life: 5000,
        });
      }
      
      startFeedBack(m = "REJECT"){

        const service = this.store.state.simforce
        switch (m) {
            case "APPROVE":
          
                service.get(
                  `/approve/approve/${this.id}`,  
                )
                .then(() => {
                  this.successFeedBack()
                })
                .catch((err: any) => {
                  this.errorFeedBack(err)
                })

            break;
            case "REQUEST":
            
                service.post(
                 `/approve/request_information/${this.id}`,
                 {
                  remarks: this.remarks,
                 }  
                )
                .then(() => {
                    this.successFeedBack()
                    this.dialogFlag = false
                    this.remarks = ""
                })
                .catch((err: any) => {
                    this.errorFeedBack(err)
                }) 
            break;
            default:

                service.get(
                  `/approve/reject/${this.id}`, 
                )
                .then(() => {
                    this.successFeedBack()
                })
                .catch((err : any) => {
                    this.errorFeedBack(err)
                })
            break;
        }

      }

  }
</script>

  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .p-button {
      width: 100%;
    }

    .p-grid {
        background:#fff;
    }

    .p-grid.p-col-12 {
      margin:0;
    }
  
    .p-field-btn {
      padding:5px !important;
    }
</style>